<template>
	<section class="statistic">
		<div class="container-2">
			<div class="statistic-info">
				<!-- <div class="statistic-element">
          <p class="font-55 f-light number">
            {{ getTotalBeneficiares }}
          </p>
          <p class="title">{{ $fn.tr("Total beneficials") }}</p>
        </div> -->
				<div class="statistic-element">
					<p class="font-55 f-light number">
						{{ getGrants }}
					</p>
					<p class="title">{{ $fn.tr('Grants') }}</p>
				</div>
				<div class="statistic-element">
					<p class="font-55 f-light number">
						{{ getGrantees }}
					</p>
					<p class="title">{{ $fn.tr('Grantees') }}</p>
				</div>
				<div class="statistic-element">
					<p class="font-55 f-light number">{{ getBudget }}</p>
					<p class="title">{{ $fn.tr('Total Funded') }}</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	computed: {
		getBudget() {
			return new Intl.NumberFormat().format(
				_.get(this.$store.state.main.indx, 'live_statistics.budget')
			);
		},
		getTotalBeneficiares() {
			return new Intl.NumberFormat().format(
				_.get(this.$store.state.main.indx, 'live_statistics.total_beneficiares')
			);
		},
		getGrants() {
			return new Intl.NumberFormat().format(
				_.get(this.$store.state.main.indx, 'live_statistics.grants')
			);
		},
		getGrantees() {
			return new Intl.NumberFormat().format(
				_.get(this.$store.state.main.indx, 'live_statistics.grantees')
			);
		},
	},
};
</script>

<style lang="scss">
.statistic {
	padding: 89px 0;
	margin-top: 90px;
	background: var(--primary);
	border: 1px solid var(--primary-border);
	@media (max-width: 1365px) {
		margin-left: auto;
		width: calc(100% - 30px);
	}
	@media (max-width: 1023px) {
		margin: auto;
		width: 100%;
		padding: 89px 0 55px;
	}
	@media (max-width: 1279px) {
		padding: 55px 0;
	}
	.statistic-info {
		display: flex;
		justify-content: space-between;
		@media (max-width: 1365px) {
			margin-bottom: 55px;
		}
		@media (max-width: 1279px) {
			margin-bottom: 0;
			flex-direction: column;
			justify-content: flex-start;
		}
		.statistic-element {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			@media (max-width: 1279px) {
				align-items: flex-start;
				margin-bottom: 34px;
			}
			.number {
				color: var(--secondary-txt);
				text-align: center;
				@media (max-width: 1365px) {
					font-size: 34px;
				}
			}
			.title {
				text-align: center;
				color: var(--white-txt);
			}
		}
	}
	// .text {
	//   color: var(--white-txt);
	//   p {
	//     color: var(--white-txt);
	//   }
	// }
}
</style>
